import * as Yup from 'yup'

export const BaseTaxonomy = Yup.object({
  translation: Yup.string(),
  id: Yup.string(),
})
